import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Br",
  "description": "",
  "published": "2009-07-10T00:00:00.000Z",
  "redirect_from": ["/blog/bruno-left-me-raped-and-confused/swizec/620"],
  "categories": "Br, Film, intrigues, Monty Python, review, Sacha Baron Cohen, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      